import React from 'react';
import PropTypes from 'prop-types';

import { Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Button from 'components/forms/Button';
import Select from 'components/forms/Select';

const TableColumnFilters = ({ options, setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    const handleSearch = () => {
        confirm();
    };

    const handleReset = () => {
        clearFilters();
    };

    return (
        <div style={{ padding: 8 }}>
            <Select
                mode="tags"
                showSearch
                placeholder="Search value"
                value={selectedKeys}
                onChange={setSelectedKeys}
                options={options.map((value) => ({ label: value, value }))}
                onPressEnter={handleSearch}
                style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={handleSearch}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90 }}
                >
                    Apply
                </Button>
                <Button onClick={handleReset} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </Space>
        </div>
    );
};

TableColumnFilters.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    // Ant-design props
    setSelectedKeys: PropTypes.func.isRequired,
    confirm: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    selectedKeys: PropTypes.array.isRequired,
};

export default TableColumnFilters;
